import ConnectionContext from 'shared/contexts/ConnectionContext'
import { FC, ReactNode, useEffect, useState } from 'react'
import get from 'lodash/get'
import jsLogger from 'js-logger'

type Props = {
  children: ReactNode
}

const ConnectionContextDataProvider: FC<Props> = ({ children }) => {
  const [connectionStatus, setConnectionStatus] = useState<
    Record<string, boolean>
  >({})

  useEffect(() => {
    const handleOnline = () => {
      jsLogger.log('[Network] Connection restored.')
      updateConnectionStatus('Net', true)
    }

    const handleOffline = () => {
      jsLogger.warn('[Network] Connection lost.')
      // setIsOnline(false)
      updateConnectionStatus('Net', false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Cleanup
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  const updateConnectionStatus = (
    connectionName: string,
    isConnected: boolean
  ) => {
    setConnectionStatus((prevStatus) => {
      const currentStatus = get(prevStatus, connectionName)
      // Only update if the value actually changes
      if (currentStatus === isConnected) {
        return prevStatus // do not trigger re-render if nothing changed
      }
      return { ...prevStatus, [connectionName]: isConnected }
    })
  }

  return (
    <ConnectionContext.Provider
      value={{ connectionStatus, updateConnectionStatus }}
    >
      {children}
    </ConnectionContext.Provider>
  )
}

export default ConnectionContextDataProvider
